<template>
  <v-dialog v-model="showDialog"  max-width="450">
    <v-card>
      <v-card-title class="text-h6 text-center">
        Importar {{ modulo }}
      </v-card-title>
      <v-card-text>
        <v-file-input
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
          label="Cargar archivo"
          placeholder="Seleccione un archivo"
        ></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="importDialog = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" text @click="importDialog = false">
          Cargar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    importDialog: Boolean,
    modulo: String,
  },
  computed: {
    showDialog() {
      if(this.importDialog){
        return true;
      }
      return false
    },
  },
};
</script>